import { ContentContainerType } from 'types/enums';
import { Grid, GridItem, Skeleton } from '@chakra-ui/react';
import { ContentContainer } from 'app/components/Core/ChakraContentContainer';

export const SoundCloudVersionAudioLoader = () => (
  <ContentContainer type={ContentContainerType.LIST} pb={24}>
    <Grid
      templateColumns="repeat(4, 1fr)"
      columnGap={4}
      w="full"
      maxW="640px"
      mx="auto"
    >
      <GridItem colSpan={{ base: 4 }}>
        <Skeleton w="full" h={12} mb={22} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={22} />
      </GridItem>
      <GridItem colSpan={{ base: 4, md: 2 }}>
        <Skeleton w="full" h={12} mb={22} />
      </GridItem>
      <GridItem colSpan={{ base: 4 }}>
        <Skeleton w="full" h={12} />
      </GridItem>
    </Grid>
  </ContentContainer>
);
